import { html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";
import { DrawShapeBaseModule } from "../../ModuleBase/shape-base-module";

export class DrawSquaresModule extends DrawShapeBaseModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	Draw(pointer, color = this.color, selectable = false) {
		let rect = new fabric.Rect({
			width: 40,
			height: 40,
			fill: color,
			stroke: "#000",
			strokeWidth: 2,
			originX: 0,
			originY: 0,
			top: pointer.y,
			left: pointer.x,
			selectable: selectable
		});
		this.canvas.add(rect);
		this.canvas.renderAll();
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                :host {
                    height: 100%;
                    width: auto;
                    position: relative;
                    right: 0px;
                    background-color: inherit;  
                }

                label {
                    display: block;
                    border: 3px solid transparent;
                    fill: gray;
                    stroke: gray;
                    cursor: pointer;
                    padding: 3px;
                    width: 100%;
                }

                label[selected] {
                   background-color:var(--primary-color);
                }

                .tag {
                    display: inline-block;
                    color: black;
                }

                label div {
                    border: solid 1px black;
                    height: 25px;
                    width: 25px;
                    text-align: center;
                }   
            </style>

            <label>
                <div class="tag" style="background-color: ${this.color}"></div>
            </label>    
        `;
	}

	constructor(canvas, color) {
		super(canvas, color);
		this.canvas = canvas;
		this.color = color;
	}
}

window.customElements.define("inspx-draw-squares", DrawSquaresModule);
